module.exports = __webpack_public_path__ + "img/user-lg.de1c87d1.png";